import { useState } from 'react';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { t } from 'i18next';
import PropTypes from 'prop-types';

const ActionButton = ({
  children,
  clickAction,
  disabled,
  startIcon,
  ...restProps
}) => {
  const [loading, setLoading] = useState(false);

  const handleClickAction = async () => {
    setLoading(true);
    await clickAction();
    setLoading(false);
  };

  return (
    <Button
      startIcon={loading ? <CircularProgress size={20} /> : startIcon}
      onClick={handleClickAction}
      {...restProps}
      disabled={disabled || loading}
    >
      {loading ? t('pending', { ns: 'buttons' }) : children}
    </Button>
  );
};

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  clickAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  startIcon: PropTypes.node,
};

export default ActionButton;
